import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../NavBar";
import { Box } from "@mui/material";
import { useCartStore } from "../../store/useCartStore";
import AppSnackbar from "../AppSnackbar";
import AppAlertDialog from "../AppAlertDialog";
import { CountdownManager } from "../routing/CountdownManager";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";

export default function Layout() {
  const cartItems = useCartStore((state) => state.cartItems);

  const showFooter = cartItems.length > 0;

  return (
    <>
      <Navbar />
      <Box
        sx={{
          pb: showFooter ? "81.02px" : 0,
          bgcolor: "background.default",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Outlet />
        <AppSnackbar />
        <AppAlertDialog />
        <CountdownManager />
        <Footer />
        <ScrollToTop />
      </Box>
    </>
  );
}
